import styled from 'libs/styled';

const G = styled('g')``;

export default G;
